"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastNotificationsColors = exports.commonPalette = exports.checklistColors = exports.activityLogColors = void 0;
var _colorUtils = require("../utils/color-utils");
var commonPalette = exports.commonPalette = {
  btnGreen: '#298784',
  sgGreen: '#298784',
  lightGreen: '#B9D6D5',
  txBlack: '#333330',
  txGrey: '#757575',
  txLightGrey: '#A3A3A3',
  borderGrey: '#ECECEC',
  darkerGray: '#f6f6f6',
  darkestGray: '#f3f3f3',
  darkGreen: '#18454c',
  ghostlyGreen: (0, _colorUtils.transparentize)('#45b192', 0.15),
  gray: '#fafafa',
  red: '#c00',
  txboxValue: '#2e2e2e',
  hoverGrey: '#F2F2F2',
  lightGrey: '#F9F9F9',
  orange: '#F79320',
  white: '#FFF',
  disabledText: '#ECECEC',
  lighterGray: '#b3b3b3',
  brightGreen: '#67D155',
  newRed: '#C33F38',
  smartSkillsGreen: '#d9f9e1',
  linkBlue: '#108ee9',
  bannerInformational: '#EBF2F9',
  iconInformational: '#0058BA',
  bannerWarning: '#FDF4ED',
  iconWarning: '#E87021',
  blue: '#1649c0',
  iconError: '#CE131C',
  bannerError: '#FEF3F3',
  iconSuccess: '#009D9A',
  bannerSuccess: '#EBF7F7',
  iconDefault: '#575F5F',
  surfaceGray2: '#F7F7F7',
  interactionHover: (0, _colorUtils.transparentize)('#040E0D', 0.05),
  interactionPressed: (0, _colorUtils.transparentize)('#040E0D', 0.1),
  highlightYellow: '#FFFF99',
  strokeDefault: '#919595',
  textSecondary: '#686E6E',
  textPrimary: '#040E0D',
  whiteSmoke: '#F2F3F3',
  darkCharcoal: '#323232',
  black: '#000',
  silver: '#EDEDED',
  blue600: '#275DBF',
  blue200: '#B2D1FB',
  orange300: '#F7C36E',
  strokeDivider: '#D2D4D3'
};
commonPalette.btnHoverGreen = (0, _colorUtils.darken)(commonPalette.btnGreen, 0.15);
commonPalette.txboxPlaceholder = (0, _colorUtils.transparentize)(commonPalette.txboxValue, 0.6);
commonPalette.bannerDefault = commonPalette.surfaceGray2;
var activityLogColors = exports.activityLogColors = {
  green: '#D2E7E6',
  lightGreen: '#E9F3F2',
  lightRed: '#E8C1BF'
};
var checklistColors = exports.checklistColors = {
  green: '#7BD398',
  red: '#E32C2C',
  white: '#FFF'
};
var toastNotificationsColors = exports.toastNotificationsColors = {
  darkGrey: '#5D5D5B',
  red: '#D3302F'
};
//# sourceMappingURL=palette.js.map